import { Check, X } from "lucide-react";

const FACTS = [
  {
    term: "Chaves no cofre",
    text: "Tokens de API ficam guardados no cofre do banco de dados e nunca chegam ao navegador.",
  },
  {
    term: "Credencial mascarada",
    text: "O painel mostra só uma versão parcial de cada credencial cadastrada.",
  },
  {
    term: "Tráfego cifrado",
    text: "O painel usa HTTPS para proteger os dados em trânsito.",
  },
] as const;

function LinkExample(): JSX.Element {
  return (
    <div className="rounded-2xl border border-border-strong bg-background/60 p-5 font-mono text-[0.8125rem] leading-relaxed sm:p-6">
      <p className="flex items-start gap-3 text-muted-foreground">
        <X size={16} className="mt-0.5 shrink-0" aria-hidden="true" />
        <span>
          <span className="sr-only">Bloqueado: </span>
          <span className="line-through decoration-foreground/50">lucralink.com.br/r/k7Qm2</span>
          <span className="block text-xs not-italic">encurtador na frente da Amazon</span>
        </span>
      </p>
      <div className="my-4 h-px bg-border" />
      <p className="flex items-start gap-3 text-foreground">
        <Check size={16} className="mt-0.5 shrink-0 text-signal" aria-hidden="true" />
        <span className="break-all">
          <span className="sr-only">Publicado: </span>
          amazon.com.br/dp/B0CX7K2M9Q?tag=<span className="whitespace-nowrap text-signal">suatag-20</span>
          <span className="block break-normal text-xs text-muted-foreground">o que o bot publica</span>
        </span>
      </p>
    </div>
  );
}

export function Seguranca(): JSX.Element {
  return (
    <section id="seguranca" aria-labelledby="seguranca-heading" className="scroll-mt-20 border-t border-border">
      <div className="mx-auto grid max-w-[77.5rem] gap-12 px-4 py-24 sm:px-6 lg:grid-cols-2 lg:items-center lg:gap-20 lg:px-8">
        <div>
          <h2
            id="seguranca-heading"
            className="max-w-[16ch] text-[clamp(2rem,1.4rem+2.2vw,3.25rem)] font-bold leading-[1.05] tracking-[-0.035em]"
          >
            Sua conta de afiliado vale mais que um clique contado.
          </h2>
          <p className="mt-6 max-w-[52ch] text-lg leading-relaxed text-muted-foreground">
            Amazon, Mercado Livre e Magalu proíbem encurtador e redirecionamento de terceiros. Quem desrespeita a regra
            arrisca ter a conta encerrada. Por isso o LucraLink bloqueia o encurtador nessas lojas por padrão e publica o
            link oficial com a sua tag.
          </p>
        </div>
        <LinkExample />
      </div>

      <dl className="mx-auto grid max-w-[77.5rem] gap-8 px-4 pb-24 sm:px-6 md:grid-cols-3 lg:px-8">
        {FACTS.map((fact) => (
          <div key={fact.term}>
            <dt className="font-semibold">{fact.term}</dt>
            <dd className="mt-2 max-w-[36ch] text-[0.9375rem] leading-relaxed text-muted-foreground">{fact.text}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
